import { render, staticRenderFns } from "./WholeLifeInsurance.vue?vue&type=template&id=45a80f44&"
import script from "./WholeLifeInsurance.vue?vue&type=script&lang=js&"
export * from "./WholeLifeInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports